var _rect, _path, _path2, _rect2, _path3, _path4, _rect3, _path5, _path6, _rect4, _path7, _path8, _rect5, _path9, _path10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 20,
    viewBox: "0 0 108 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#00B67A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 8.34993H11.6514L10.0049 3L8.34864 8.34993L3 8.33968L7.32568 11.6501L5.66945 17L9.99513 13.6896L14.3208 17L12.6743 11.6501L17 8.34993Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 12.6454V11.0502L10 13.5002L13.5 12.6454Z",
    fill: "#00B67A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 22,
    width: 20,
    height: 20,
    fill: "#00B67A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39 8.34993H33.6514L32.0049 3L30.3486 8.34993L25 8.33968L29.3257 11.6501L27.6695 17L31.9951 13.6896L36.3208 17L34.6743 11.6501L39 8.34993Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5 12.6454V11.0502L32 13.5002L35.5 12.6454Z",
    fill: "#00B67A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    width: 20,
    height: 20,
    fill: "#00B67A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61 8.34993H55.6514L54.0049 3L52.3486 8.34993L47 8.33968L51.3257 11.6501L49.6695 17L53.9951 13.6896L58.3208 17L56.6743 11.6501L61 8.34993Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 12.6454V11.0502L54 13.5002L57.5 12.6454Z",
    fill: "#00B67A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 66,
    width: 20,
    height: 20,
    fill: "#00B67A"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83 8.34993H77.6514L76.0049 3L74.3486 8.34993L69 8.33968L73.3257 11.6501L71.6695 17L75.9951 13.6896L80.3208 17L78.6743 11.6501L83 8.34993Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M79.5 12.6454V11.0502L76 13.5002L79.5 12.6454Z",
    fill: "#00B67A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    width: 20,
    height: 20,
    fill: "#00B67A"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M105 8.34993H99.6514L98.0049 3L96.3486 8.34993L91 8.33968L95.3257 11.6501L93.6695 17L97.9951 13.6896L102.321 17L100.674 11.6501L105 8.34993Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.5 12.6454V11.0502L98 13.5002L101.5 12.6454Z",
    fill: "#00B67A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.2f7d72b9edae804f76c4c572ac10809e.svg";
export { ForwardRef as ReactComponent };